import React from 'react';
import { Helmet } from 'react-helmet';
import useCursor from '@ui/hooks/useCursor';
import useDictionary from '@ui/hooks/useDictionary';
import CookiesPolicyContainer from '@ui/features/Cookies-policy/Cookies-policy.container';

export default function withPage<T extends JSX.IntrinsicAttributes>(
    Component: React.FC<T>,
    selector: string,
    title: string,
) {
    return (props: T) => {
        const getWord = useDictionary();
        const cursor = useCursor();
        return (
            <>
                <Helmet>
                    <title>{getWord(title ?? 'VegaMX')}</title>
                </Helmet>
                <div
                    className={selector}
                    style={{
                        cursor,
                    }}
                >
                    <Component {...props} />
                </div>
                <CookiesPolicyContainer />
            </>
        );
    };
}
